import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {ErrorService} from '@app/services';
import {RouteSearchParams} from '../route-search-params';
import {RouteService} from '../route.service';
@Component({
  selector: 'hpf-route-count',
  templateUrl: './route-count.component.html'
})
export class RouteCountComponent implements OnInit {
  /** The filters */
  @Input() searchParams: RouteSearchParams = new RouteSearchParams();
  /** Count result */
  count: number;
  /** Load flag */
  loaded = false;
  /** Constructor */
  constructor(private routeService: RouteService,
              private errorService: ErrorService) {}
  /** Init */
  ngOnInit() {
    this.routeService.count(this.searchParams.toObject())
    .then((count) => {
      this.count = count;
      this.loaded = true;
    })
    .catch((error) => this.errorService.handle(error))
  }
}
